import PropTypes from 'prop-types';
import Icon from '../../../Icon/Icon';
import { FormattedMessage } from 'react-intl';

const acceptanceInfo = {
  accept: {
    text: <FormattedMessage
      id="rIbqjm"
      description="Accepting"
      defaultMessage="Accepting referrals"
    />,
    icon: <Icon icon="CheckCircle" color="green" className="mr-1 my-auto" />,
  },
  deny: {
    text: <FormattedMessage
      id="l8K7Nm"
      description="not-accepting"
      defaultMessage="Not accepting referrals"
    />,
    icon: <Icon icon="TimesCircle" color="red" className="mr-1 my-auto" />,
  },
};

function ProgramAcceptance(props) {
  const {
    receiving_referrals,
    status = '',
  } = props;

  return (
    <div className="flex mt-2 text-sm items-center">
      {
        receiving_referrals ?
          acceptanceInfo.accept.icon :
          acceptanceInfo.deny.icon
      }
      {
        receiving_referrals ?
          acceptanceInfo.accept.text :
          acceptanceInfo.deny.text} {status && `(${status})`
      }
    </div>
  );
}

ProgramAcceptance.propTypes = {
  receiving_referrals: PropTypes.bool.isRequired,
  status: PropTypes.string,
};

export default ProgramAcceptance;
